import { Inclusion } from '@/diagnostic/domain/Inclusion.ts';

export type InclusionPayload = 'INCLUDE' | 'EXCLUDE';

export const inclusionToPayload = (inclusion: Inclusion): InclusionPayload => {
  switch (inclusion) {
    case Inclusion.Include:
      return 'INCLUDE';
    case Inclusion.Exclude:
      return 'EXCLUDE';
  }
};
